module.exports = __webpack_public_path__ + "media/slide-0.3ee340a6.mp4";